import { SECTION_CONFIG } from '../../constants/section-config';
import { trackOnwardClick as trackOnwardClickWithConfig } from '$global/utils/onwardClick/trackOnwardClick/trackOnwardClick';
import type { TrackOnwardClickInput } from '$global/utils/onwardClick/trackOnwardClick/trackOnwardClick';

export type TrackHeniOnwardClickInput = Omit<TrackOnwardClickInput, 'config'>;

/**
 * `onward_click` bound to the heni.com route map (HB-967).
 *
 * Call sites use this rather than the global-v5 function directly, so the
 * section config is named in exactly one place.
 */
export const trackOnwardClick = (input: TrackHeniOnwardClickInput): boolean =>
	trackOnwardClickWithConfig({ ...input, config: SECTION_CONFIG });
